import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';


// var cards = new Swiper(".cards-carousel", {
// 	autoplay: {
// 		enabled: true,
// 		delay: 6000,
// 	},
// 	pagination: {
// 		el: ".swiper-pagination",
// 		clickable: true,
// 	},
// });


var careers = new Swiper(".careers-carousel", {
	autoplay: {
		enabled: false,
		delay: 6000,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		300: {
		  slidesPerView: 1.5,
		  spaceBetween: 20,
		},
		768: {
		  slidesPerView: 2.5,
		  spaceBetween: 20,
		},
		1024: {
		  slidesPerView: 3.5,
		  spaceBetween: 20,
		},
		1400: {
		  slidesPerView: 3.5,
		  spaceBetween: 15,
		},
	},
});

var timeline = new Swiper(".timeline-carousel", {
	autoplay: {
		enabled: false,
		delay: 6000,
	},
	slidesPerView: 2.5,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
});


var testimonial = new Swiper(".testimonial-carousel", {
	autoplay: {
		enabled: false,
		delay: 6000,
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		300: {
		  slidesPerView: 1.5,
		  spaceBetween: 20,
		},
		600: {
		  slidesPerView: 2.5,
		  spaceBetween: 20,
		},
		1024: {
		  slidesPerView: 3,
		  spaceBetween: 20,
		},
		1280: {
		  slidesPerView: 3.5,
		  spaceBetween: 20,
		},
	},
});

var services = new Swiper(".services-carousel", {
	autoplay: {
		enabled: false,
		delay: 6000
	},
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	slidesPerView: 1.25,
	spaceBetween: 32,
	breakpoints: {
		200: {
			slidesPerView: 1.25,
			spaceBetween: 32
		},
		580: {
			slidesPerView: 2.15,
			spaceBetween: 32
		},

		768: {
			slidesPerView: 2.5,
			spaceBetween: 32
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 40
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 60
		},
	}
});

var services = new Swiper(".gallery-carousel", {
	spaceBetween: 0,
	direction: 'horizontal',
	autoplay: {
		enabled: false,
	},
	loop: true,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	slidesPerView: 1.25,
	spaceBetween: 32,
	breakpoints: {
		200: {
			slidesPerView: 1.25,
			spaceBetween: 32
		},
		580: {
			slidesPerView: 2.15,
			spaceBetween: 32
		},

		768: {
			slidesPerView: 2.5,
			spaceBetween: 32
		},
		1024: {
			slidesPerView: 3,
			spaceBetween: 40
		},
		1280: {
			slidesPerView: 3,
			spaceBetween: 60
		},
	}
});

var customers = new Swiper(".customer-carousel", {
	spaceBetween: 0,
	speed:5000,
	direction: 'horizontal',
	autoplay: { 
		enabled: true,
		delay: 0,
	},
	loop: true,
	freeMode: true,
	slidesPerView: 'auto',
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		200: {
			spaceBetween: 40
		},
		600: {
			spaceBetween: 40
		},
		1024: {
			spaceBetween: 40
		},
		1280: {
			spaceBetween: 96
		},
	}
});

var partners = new Swiper('.partners-carousel', {
	spaceBetween: 0,
	speed:5000,
	direction: 'horizontal',
	autoplay: { 
		enabled: true,
		delay: 0,
	},
	loop: true,
	freeMode: true,
	slidesPerView: 'auto',
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	breakpoints: {
		200: {
			spaceBetween: 40
		},
		600: {
			spaceBetween: 40
		},
		1024: {
			spaceBetween: 40
		},
		1280: {
			spaceBetween: 96
		},
	}
});


var heroBanner = new Swiper(".hero-banner-slider", {
	effect: "fade",
	spaceBetween: 0,
	navigation: {
		nextEl: '.swiper-button-next',
		prevEl: '.swiper-button-prev',
	},
	slidesPerView: 1,
});